import { credentialStatusLabel } from 'src/components/property/UtilityPortalCredentials/credentialStatus';

/**
 * Pure filtering for the credential list. Extracted so the search fields and the status derivation
 * are testable without mounting a DataGrid.
 */

/**
 * Fields the free-text box matches.
 *
 * `usernameHint` is already masked by the API, so searching it is safe. There is no password field
 * in any list payload, which is why none appears here.
 */
export const SEARCHABLE_FIELDS = ['companyName', 'propertyAddress', 'serviceAddress', 'providerKey', 'usernameHint', 'accountReference', 'propertyReference'];
export const filterCredentials = function (credentials) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$search = _ref.search,
    search = _ref$search === void 0 ? '' : _ref$search,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$providerKey = _ref.providerKey,
    providerKey = _ref$providerKey === void 0 ? '' : _ref$providerKey;
  const rows = Array.isArray(credentials) ? credentials : [];
  const term = search.trim().toLowerCase();
  return rows.filter(row => {
    if (providerKey && row.providerKey !== providerKey) return false;
    // Compared on the label, not the raw status: the label is what the operator picked from, and
    // it folds a disabled credential and an expired one into the words shown on the chip.
    if (status && credentialStatusLabel(row) !== status) return false;
    if (!term) return true;
    return SEARCHABLE_FIELDS.some(field => (row[field] || '').toLowerCase().includes(term));
  });
};

/** Status labels actually present in these rows, so the dropdown cannot offer an empty filter. */
export const statusOptions = credentials => [...new Set((Array.isArray(credentials) ? credentials : []).map(credentialStatusLabel).filter(Boolean))].sort();